import { render, staticRenderFns } from "./AdminInvoiceItemFormTable.vue?vue&type=template&id=175b8bd0&scoped=true&"
import script from "./AdminInvoiceItemFormTable.vue?vue&type=script&lang=ts&"
export * from "./AdminInvoiceItemFormTable.vue?vue&type=script&lang=ts&"
import style0 from "./AdminInvoiceItemFormTable.vue?vue&type=style&index=0&id=175b8bd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175b8bd0",
  null
  
)

export default component.exports
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QMarkupTable,QBtn});
